import React, { useState, useContext } from "react";
import classes from "./ValidationBox.module.css";
import { useTranslation } from "react-i18next";
import serverPostData from "../../utils/ServerPostData";
import DarkModeContext from "../../store/DarkModeContext";
import { lightModeColors, darkModeColors } from "../../utils/colors";
import ConfirmModal from "./ConfirmModal";

export default function ValidationBox() {
  const [tg] = useTranslation("global");
  const [inputValue, setInputValue] = useState("");
  const [email, setEmail] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [prizeName, setPrizeName] = useState("");
  const [prizeDescription, setPrizeDescription] = useState("");
  const [prizeRedeemed, setPrizeRedeemed] = useState("");
  const [userAge, setUserAge] = useState("");
  const [prizeValue, setPrizeValue] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const { darkMode } = useContext(DarkModeContext);
  const { cardColor } = darkMode ? darkModeColors : lightModeColors;

  const handleInputChange = (event) => {
    const onlyDigits = event.target.value.replace(/\D/g, "");
    let formatted = onlyDigits.slice(0, 3);
    if (onlyDigits.length > 3) formatted += "-" + onlyDigits.slice(3, 6);
    if (onlyDigits.length > 6) formatted += "-" + onlyDigits.slice(6, 9);
    setInputValue(formatted);
  };

  const handleVerifyClick = async (event) => {
    event.preventDefault();
    const cleanCode = inputValue.replace(/\D/g, "");

    const formData = new FormData();
    formData.set("email", email);
    formData.set("code", cleanCode);

    try {
      const response = await serverPostData("/validate-redeem-code", formData);
      const data = response;

      if (data.status === 200 && data.data.response_code === 0) {
        setPrizeName(data.data.title);
        setPrizeDescription(data.data.description);
        setPrizeValue(data.data.points);
        setPrizeRedeemed(data.data.redeemed ? "Sim" : "Não");
        setUserAge(data.data.legal_age ? "Sim" : "Não");
        setUserEmail(data.data.email);
        setShowModal(true);
      } else {
        let alertText = "";
        switch (data.data.response_code) {
          case 1:
            alertText = tg("prizes.validate_code.already_redeemed");
            break;
          case 2:
            alertText = tg("prizes.validate_code.invalid_code");
            break;
          case 3:
            alertText = tg("prizes.validate_code.user_not_found");
            break;
          default:
            alertText = tg("global.general.error");
        }
        alert(alertText);
      }
    } catch (error) {
      console.error("Erro:", error);
      alert(tg("global.general.error"));
    }
  };

  const handleConfirm = async () => {
    setShowModal(false);

    const formData = new FormData();
    formData.set("email", email);
    formData.set("code", inputValue.replace(/\D/g, ""));

    try {
      const confirmResponse = await serverPostData("/confirm-redeem-code", formData);
      const confirmData = confirmResponse;

      if (confirmData.status === 200 && confirmData.data.response_code === 0) {
        alert(`${tg("prizes.validate_code.success")}:\n${prizeName}`);
        cancelInput();
      } else {
        alert(tg("global.general.error"));
      }
    } catch (error) {
      alert(tg("global.general.error"));
    }
  };

  const handleCancel = () => {
    setShowModal(false);
  };

  const cancelInput = () => setInputValue("");

  return (
    <div className={classes.box} style={{ "--card-color": cardColor }}>
      <h1 className={classes.titulo}>{tg("prizes.validate_code.title")}</h1>
      <form onSubmit={handleVerifyClick}>
        {/* Se quiser ativar o email, descomente:
        <input
          type="text"
          placeholder={tg("prizes.validate_code.email")}
          className={classes.emailBox}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        */}
        <input
          type="text"
          placeholder={tg("prizes.validate_code.code")}
          className={classes.codeBox}
          value={inputValue}
          onChange={handleInputChange}
          maxLength={12}
          required
        />
        <div style={{ display: "flex", justifyContent: "space-evenly" }}>
          <button type="button" className={classes.cancel} onClick={cancelInput}>
            {tg("prizes.validate_code.cancel")}
          </button>
          <button className={classes.submit} type="submit">
            {tg("prizes.validate_code.verify")}
          </button>
        </div>
        <br />
        <label>
          <h4 style={{ marginRight: "1rem" }}>
            {tg("prizes.miscellaneous.anyDoubtContact")}
          </h4>
          <a
            style={{ textDecoration: "underline", color: "blue", fontSize: "inherit" }}
            href="mailto:ursoverde.feedback@gmail.com?subject=Validação%20de%20prémios%20|%20Estabelecimentos%20Aderentes"
          >
            ursoverde.feedback@gmail.com
          </a>
        </label>
        <br />
        <a
          href="https://forms.gle/cYTNCfrveWZhvXCUA"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: "inline-block",
            marginTop: "0.5rem",
            backgroundColor: "#28a745",
            color: "white",
            padding: "0.5rem 1rem",
            borderRadius: "5px",
            textDecoration: "none",
            fontSize: "0.9rem",
            textAlign: "center"
          }}
        >
          Problemas e Sugestões
        </a>

      </form>

      {showModal && (
        <ConfirmModal
          message={{
            "Prémio": prizeName,
            "Descrição": prizeDescription,
            "Email do utilizador": userEmail,
            "Utilizador maior de idade (+18)": userAge,
            "Pontos": prizeValue,
            "Redimido": prizeRedeemed,
          }}
          onConfirm={handleConfirm}
          onCancel={handleCancel}
        />
      )}
    </div>
  );
}
